import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportProgressReport_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportProgressReport extends Report<ReportProgressReport_Settings> {

    static reportName: string = "Progress report"

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_PROGRESS_REPORT
        super(data);

        this.icon         = "isvg-progress-report"
        this.description  = "Detailed task progress over a selected period of time, with a breakdown of created, completed, and in-progress tasks."

        this.settings     = new ReportProgressReport_Settings(data.settings)
    }

    static initFromSavedView(savedView:SavedView):ReportProgressReport {
        return new ReportProgressReport(savedView.toReportConfig())
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportProgressReport_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

    applyProjectScope(projectId: ID) {
        super.applyProjectScope(projectId)

        this.settings.projectIds = [projectId]
    }

    save(){
        console.log("Not implemented")
    }
}
